<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Tag</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Tag Name"
                        name="name"
                        type="textarea"
                        placeholder="Tag Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.name">
            </base-input>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="12" md="6">
            <base-input label="Tag Group">
              <el-select
                  v-model="model.tagGroupId" 
                  filterable
                  placeholder="Select Tag Group"
                  rules="required"
                  single
                  value-key="id"
              >
                <el-option v-for="option in tagCategories"
                              :key="option.id"
                              :label="option.name"
                              :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="12" md="6">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="12">
            <label class="form-control-label">
              Tag Icon
            </label>
            
            <div class="dropzone-icon">
               <loading-panel v-show="loadingIcon"></loading-panel>
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="logoDropzone"
                  :options="dropzoneOptions"
                  single
                  ref="iconUpload"
                  v-show="!loadingIcon"
                />
             </div>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Tag</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  //import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'
  import LoadingPanel from '../../components/LoadingPanel.vue';
  import vue2Dropzone from 'vue2-dropzone'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/tags/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditTag",
    components: {
        HtmlEditor,
        vue2Dropzone,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions,
        LoadingPanel
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          tagGroupId: '',
          icon: '',
          dropzone: [],
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true,
        },
        loadingIcon: true,
        iconId: '',
        iconUpload: [],
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          maxFiles: 1,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if (this.model.name) {

          if ( this.$refs.iconUpload.dropzone.files[0] && !this.$refs.iconUpload.dropzone.files[0].manuallyAdded  ) {
            this.model.iconUpload = this.$refs.iconUpload.dropzone.files[0];
            delete this.model.iconId;
            delete this.model.icon;
          } else if ( this.$refs.iconUpload.dropzone.files[0] && this.$refs.iconUpload.dropzone.files[0].manuallyAdded ) {
            this.model.iconUpload = null;
          } else {
            if(this.iconId){
              this.model.iconUpload = {};
              this.model.iconUpload.delete = { 'uuid': `${this.iconId}` }
            }
          }

          
          try {
              dispatch("tags/updateTag", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Tag Updated'});
                  this.$router.push({path: "/tags"});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: recipe add", error);
          }
        }
      },
      getTag(id) {
        return apiClient.get(`${id}`);
      },
      loadCurrentImage() {
        if (this.model.icon) {
          var mockFile = { name: this.model.icon.name, size: 50000, type: 'image', id: this.model.icon.id};
          this.iconId = this.model.icon.id;
          this.$refs.iconUpload.manuallyAddFile(mockFile, this.model.icon.absoluteUri);
          
        } else {
          this.loadingIcon = false;
        }
        
      },
      maxFilesExceeded(file) {
        this.$refs.iconUpload.removeAllFiles()
        this.$refs.iconUpload.addFile(file)
        this.iconUpload = file
      },
      fileAdded(file) {
        this.iconUpload = file
      }
    },
    computed: {
      tagCategories() {
        return this.$store.state.taggroups.selectList
      }
    },
    created() {
      this.$store.dispatch('taggroups/getSelectList');
      this.model.id = this.$route.params.id;
      this.getTag(this.model.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          console.log(error)
        });
      setTimeout(() => {
        this.loadCurrentImage();
          this.loadingIcon = false;
        }, 3600);
    },
    mounted() {
      
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}

.tag-icon {
  width: 200px;
  height: 200px;
}
</style>
